export default "__VITE_ASSET__DfJWfO39__"